import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutGooglePlacesSearch extends Layout {
    sourceGooglePlaces: DataSource;
    tableGooglePlaces: Table;
}
